const paths = {
  HISTORY: 'history',
  HOME: 'home',
  SETTINGS: 'settings',
};

export { paths };
